import { FC } from 'react'
import { Passo, PassoBotao, PassoCampo } from '../styles'

export interface StepperProps {
  valor: string
  aoMudar: (valor: string) => void
  rotulo: string
  min?: number
  max?: number | null
  disabled?: boolean
}

/**
 * OP-3619 — quantidade por toque.
 *
 * Quem separa está de pé, com caixa na mão: um campo de 90px não se acerta
 * com o polegar. Os botões mexem de um em um e o campo continua editável,
 * para quando a quantidade é 200.
 */
export const Stepper: FC<StepperProps> = ({ valor, aoMudar, rotulo, min = 0, max = null, disabled }) => {
  const atual = Number(valor)
  const numero = Number.isFinite(atual) ? atual : min
  const limitar = (n: number): number => {
    if (n < min) return min
    if (max != null && n > max) return max
    return n
  }

  return (
    <Passo>
      <PassoBotao
        type="button"
        aria-label={`Menos um: ${rotulo}`}
        disabled={disabled || numero <= min}
        onClick={() => aoMudar(String(limitar(numero - 1)))}
      >
        −
      </PassoBotao>
      <PassoCampo
        type="number"
        inputMode="numeric"
        min={min}
        max={max ?? undefined}
        aria-label={rotulo}
        value={valor}
        disabled={disabled}
        onChange={(e) => aoMudar(e.target.value)}
      />
      <PassoBotao
        type="button"
        aria-label={`Mais um: ${rotulo}`}
        disabled={disabled || (max != null && numero >= max)}
        onClick={() => aoMudar(String(limitar(numero + 1)))}
      >
        +
      </PassoBotao>
    </Passo>
  )
}

export default Stepper
